import BaseModel from './BaseModel';

export default class Genre extends BaseModel {

    constructor(data) {
        super(data);
        this.id = data.id || data.ID;
        this.name = data.name || data.Name;
        this.description = data.description || data.Description
    }
}


// WEBPACK FOOTER //
// ../hasta-la-vista-middleware-api/src/model/Genre.js